<div class="text-center">
  <mat-icon>arrow_circle_up</mat-icon>
  <h1 mat-dialog-title translate> dialog.slot.mass_import.title</h1>

  <div class="modal-body" mat-dialog-content>

    <mat-form-field class="def-select single-element-select mr-3" appearance="outline" floatLabel="always">
      <mat-label translate>dialog.slot.mass_import.dateBegin</mat-label>
      <input  matInput 
              [matDatepicker]       = "pickerDateBegin" 
              [(ngModel)]           = "dateBegin" 
              [min]                 = "currentDate"
              [max]                 = "dateEnd"
              [matDatepickerFilter] = "excludeToday"
              (click)               = "pickerDateBegin.open()"
              readonly>
          <mat-datepicker-toggle matSuffix [for]="pickerDateBegin"></mat-datepicker-toggle>
      <mat-datepicker #pickerDateBegin></mat-datepicker>
    </mat-form-field>
    
    <mat-form-field class="def-select single-element-select" appearance="outline" floatLabel="always">
      <mat-label translate>dialog.slot.mass_import.dateEnd</mat-label>
      <input  matInput   
              [matDatepicker]       = "pickerDateEnd" 
              [(ngModel)]           = "dateEnd" 
              [min]                 = "dateBegin"
              readonly 
              [matDatepickerFilter] = "excludeToday"
              (click)               = "pickerDateEnd.open()">
          <mat-datepicker-toggle matSuffix [for]="pickerDateEnd"></mat-datepicker-toggle>
      <mat-datepicker #pickerDateEnd ></mat-datepicker>
    </mat-form-field>

    <div class="card container">
      
      <div id="day-container" class="my-3">
        <div *ngFor="let day of dayList" class="day-content col-md-4">
          <mat-checkbox [(ngModel)] = "day.active">
            <span translate> {{ day.day }} </span>
          </mat-checkbox>
        </div>
      </div>

    </div>

    <div class="card container mt-3">
      
      <div class="row mt-3">
        
        <div class = "col">
          
          <custom-select #OperationSelect
                         adaptive        =   "true"
                         autoSelectFirst =   "true"
                         [values]        =   "operations"
                         [title_multiple]=   "operations_title"
                         (change)        =   "operationChange($event)"
                         class           =   ""></custom-select>

        </div>
        
      </div>

    </div>

    <div class="card container mt-3">
  
      <div class="row mt-3">
        
        <div class = "col">
          <mat-checkbox [(ngModel)] = "holidays">
            <span translate>dialog.slot.mass_import.included_holiday</span>
          </mat-checkbox>  
        </div>
        
        
      </div>
      <div class="row mt-3">
        
        <div class = "col" *ngIf="service && service.serviceCode">
          <mat-checkbox [(ngModel)] = "byServiceCode">
            <span translate>dialog.slot.mass_import.multiple_service</span>
          </mat-checkbox>  
        </div>
        
        
      </div>
    </div>

    <div class="card container mt-3" *ngIf="byServiceCode == 1">
      <site-autocomplete  #sitesManager [orgId]="orgId" [service]="service"></site-autocomplete>
    </div>


  </div>

  <div class="modal-footer" mat-dialog-actions translate>

    <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
      dialog.slot.mass_import.generic.cancel
    </button>

    <button type="button" class="btn btn-outline-secondary" (click)="create()" translate>
      dialog.slot.mass_import.create
    </button>

  </div>